import {FunctionComponent, useMemo, useState} from "react";
import {KeyedVisualisationData} from "../../models/visualisation-data.interface";
import styles from "./MobileClusterController.module.css";
import ClusterGroup from "../cluster-group/ClusterGroup";
import ArrowButton from "../arrow-button/ArrowButton";

const MobileClusterController: FunctionComponent<{dataGroups: KeyedVisualisationData[], width: number}> = ({dataGroups, width}) => {
  const [step, setStep] = useState(0);
  const entries = useMemo(() => dataGroups.map(d => Object.entries(d)), [dataGroups]);

  return (
    <div className={styles.container}>
      <ClusterGroup dataGroup={[entries[0][step][1], entries[1][step][1]]} width={width} isLast={true}/>
      <div className={styles.controlContainer} style={{alignItems: entries[1][step][0].length > 15 ? "flex-end" : "baseline" }}>
        <ArrowButton
          callbackFn={() => setStep((s) => s - 1)}
          disabled={step === 0}
          left={true}
        >Prev</ArrowButton>
          <h3 className={styles.title}>{entries[1][step][0]}</h3>
        <ArrowButton
          callbackFn={() => setStep((s) => s + 1)}
          disabled={step === entries[1].length - 1}
        >Next</ArrowButton>
      </div>
    </div>
  );
}

export default MobileClusterController;
